export default __webpack_public_path__ + "static/Firefox-62df179f6dfaa828e0d9f0e6beff0432.svg";